module.exports = __webpack_public_path__ + "static/media/button2.0336ae14.png";